import { render, staticRenderFns } from "./ForumWarning.vue?vue&type=template&id=1c05c526&scoped=true&"
import script from "./ForumWarning.vue?vue&type=script&lang=js&"
export * from "./ForumWarning.vue?vue&type=script&lang=js&"
import style0 from "./ForumWarning.vue?vue&type=style&index=0&id=1c05c526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05c526",
  null
  
)

export default component.exports